import { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { withStyles } from '@material-ui/core/styles';
import ImgPreview from '../../../imgActions/ImgPreview';
import getCroppedImg from '../../../imgActions/cropImg';
import { styles } from '../../../imgActions/styles';
import "../../../styles/uploadImg.css";

const UploadImg = ({ classes, closeModal }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);

  const imgChange = (e) => {
    if(e.target.files[0]) {
      const url = URL.createObjectURL(e.target.files[0]);
      setImgPreview(url);
    }
  }

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(imgPreview, croppedAreaPixels);
      setCroppedImage(croppedImage)
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, imgPreview]);

  const onClose = useCallback(() => {
    setCroppedImage(null)
  }, [])

  return (
    <>
      <button className="closeUploadModal" onClick={() => closeModal()}>X</button>
      <div className="cropImgContainer">
        <div className={classes.cropContainer}>
          <Cropper
            image={imgPreview}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        <h1 className="text-white">Supported Format: JPG, PNG, WEBP</h1>

        <div className="upload-controls">
          <label htmlFor="inputUpload" className="uploadBtn">Upload Image</label>
          <input type="file" id="inputUpload" onChange={imgChange} className="hidden" />
          <button 
            onClick={showCroppedImage}
            className="cropImgBtn"
          >
            Insert Image
          </button>
        </div>
        <ImgPreview img={croppedImage} onClose={onClose} />
      </div>
    </>
  )
}

const UploadImgMain = withStyles(styles)(UploadImg)

export default UploadImgMain;